// removed by extract-text-webpack-plugin
module.exports = {"footer":"s_t","container":"s_g","hr":"s_u","logo":"s_v","social":"s_w _17N5TnXuu_48M9r3JbA-1_ _2HU8ZgmfpIdsUwklJ4Ng6B _3JIEYde9anI6O5H5wYv2ik","socialIcon":"s_x","copyright":"s_y _2ybzRVdUFjC6oEY7VXWN7T ustYG-AEFrKkEkfpoRiw-","sections":"s_z","lists":"s_aa s_z _3WCCq13R86ci-P4gMMM_yg ustYG-AEFrKkEkfpoRiw-","logoSection":"s_ab s_z","socialSection":"s_ac s_z","smallPrint":"s_ae s_g","getInTouch":"s_af","getInTouchLink":"s_ag","about":"s_ah"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Footer/styles.module.css
// module id = 1057
// module chunks = 27